<script>
  import {cn} from "$lib/utils.js";
  import Heading from "./bits/calendar-heading.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<Heading bind:ref class={cn("text-sm font-medium", className)} {...restProps}/>
